// extracted by mini-css-extract-plugin
export default {"root":"NOHEfficiencyLineChart_root__aDgzq","yUnitLabel":"NOHEfficiencyLineChart_yUnitLabel__uzCFD"};